<template>
  <v-row>
    <v-col cols="12">
      <h4 class="mb-0 fieldset-title">محصولات و خدمات کسب و کار</h4>
    </v-col>
    <v-col cols="12">
      <BaseTable
        :headers="fields"
        :items="items"
        tableClasses="item-table border"
        responsive
        hide-default-footer
        fixed-header
        ref="baseTable"
        height="200"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            title="حذف"
            color="error"
            @click="$emit('removeFromList', item)"
          >
            <v-icon> mdi-delete </v-icon>
          </v-btn>
        </template>
      </BaseTable>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'MerchantCategoryComponent',
  props: {
    items: {
      type: Array,
    },
    fields: Array,
  },
};
</script>
<style scoped>
.fieldset-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 33px;
  color: #006298;
  text-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}
</style>
